// extracted by mini-css-extract-plugin
export default {"button":"OrderCard_button__hj+ro","self":"OrderCard_self__F7D77"};